<template>
  <div class="container pb-5">
    <ol class="breadcrumb arr-right mb-0 mb-md-3 mt-0 mt-md-5">
      <li class="breadcrumb-item">
        <router-link :to="{ name: 'bankHolidays' }" class="headings">{{
          $t('holidays.index.title')
        }}</router-link>
      </li>
      <li class="breadcrumb-item reference-heading heading-color">
        {{ $t('holidays.index.list') }}
      </li>
    </ol>
    <h5 class="heading-color">{{ holidays.title }}</h5>
    <b-table
      class="text-left holiday-table"
      bordered
      :items="holidays.list"
      :fields="holidays.fields"
      caption-top
    >
      <template #table-caption>{{ holidays.subtext }}</template>
    </b-table>
  </div>
</template>

<script>
import { bankHolidays } from '@/modules/cms'

export default {
  data() {
    return {
      holidays: {
        fields: ['holiday', 'day', 'date'],
        list: [],
        title: '',
        subtext: ''
      }
    }
  },
  mounted() {
    this.getHolidayList()
  },
  methods: {
    getDayByDate(date) {
      return this.$dayjs(date, 'MMMM D, YYYY').format('dddd').toString()
    },
    getHolidayList() {
      const usHolidays = bankHolidays.US
      this.holidays.title = usHolidays.title
      this.holidays.subtext = usHolidays.subtext
      this.holidays.list = usHolidays.list.map((item) => ({
        ...item,
        day: this.getDayByDate(item.date)
      }))
    }
  }
}
</script>
